export enum ECouponType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}
